import { PricingOffersWarrantyType } from "../binders/binders.types";
import { CreatePricingDetailsInput } from "../pricing/pricing.types";


export const DerogationType = {
  PRICING: "PRICING",
  CONSTRUCTION_COST: "CONSTRUCTION_COST",
  DURATION: "DURATION",
} as const;

export type DerogationTypeValues =
  (typeof DerogationType)[keyof typeof DerogationType];
export interface ConstructionSiteDerogationItem {
  id: number;
  enabled: boolean;
  type: DerogationTypeValues | null;
  newConstructionCost?: number | null;
  newDeliveryDate?: string | null;
  selectedOffersIds: number[];
}

export type GetConstructionSiteDerogationsResponse =
  ConstructionSiteDerogationItem[];

export interface UpdateConstructionSiteDerogationBody {
  enabled: boolean;
  type: DerogationTypeValues;
  newConstructionCost?: number | null;
  newDeliveryDate?: string | null;
}

export interface UpdateConstructionSiteDerogationsBody {
  derogations: UpdateConstructionSiteDerogationBody[];
  newPricingDetails?: Record<PricingOffersWarrantyType, CreatePricingDetailsInput>;
  selectedOffersIds?: number[];
}


